<dialog #dialog class="overlay" (click)="onClickOut($event)" (cancel)="onCancel($event)">
  <div class="overlay-body">
    @if (title) { <h2 class="h3 overlay-title">{{ title }}</h2> }
    <div class="overlay-content">
      <ng-content></ng-content>
    </div>
    @if (dismissable) {
      <div class="overlay-close">
        <ng-content select="[overlayAction]"></ng-content>
        <button type="button" class="atmos-btn atmos-btn--sm" (click)="onClose($event)">{{ closeText }}</button>
      </div>
    }
  </div>
</dialog>
